import { CheckOutlined } from "@ant-design/icons";

export const getTipoTagProps = (tipo) => {
  if (!tipo) return { color: "default", icon: null };
  if (tipo.includes("Entrega"))
    return { color: "red", icon: <CheckOutlined /> };
  if (tipo.includes("Reingreso"))
    return { color: "green", icon: <CheckOutlined /> };
  if (tipo.includes("Recepcion"))
    return { color: "geekblue", icon: <CheckOutlined /> };
  if (tipo.includes("Transferencia"))
    return { color: "gold", icon: <CheckOutlined /> };
  return { color: "default", icon: null };
};
